export enum SelectionSyncMessageType {
  SelectParts = 'physna:selection:select-parts',
  PartSelected = 'physna:selection:part-selected',
  ClearSelection = 'physna:selection:clear',
}

export type SelectionSyncSource = 'parent' | 'viewer';

export type SelectPartsMessage = {
  type: SelectionSyncMessageType.SelectParts;
  src: SelectionSyncSource;
  assetIds: string[];
  dependencyPaths?: string[];
};

export type PartSelectedMessage = {
  type: SelectionSyncMessageType.PartSelected;
  src: SelectionSyncSource;
  nodeNames: string[];
  assetIds: string[];
};

export type ClearSelectionMessage = {
  type: SelectionSyncMessageType.ClearSelection;
  src: SelectionSyncSource;
};

export const isSelectPartsMessage = (value: unknown): value is SelectPartsMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown; assetIds?: unknown };
  return message.type === SelectionSyncMessageType.SelectParts && Array.isArray(message.assetIds);
};

export const isPartSelectedMessage = (value: unknown): value is PartSelectedMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown; nodeNames?: unknown; assetIds?: unknown };
  return (
    message.type === SelectionSyncMessageType.PartSelected &&
    Array.isArray(message.nodeNames) &&
    Array.isArray(message.assetIds)
  );
};

export const isClearSelectionMessage = (value: unknown): value is ClearSelectionMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown };
  return message.type === SelectionSyncMessageType.ClearSelection;
};

export const extractAssetIdFromNodeName = (nodeName: string): string => nodeName.slice(0, nodeName.lastIndexOf('-'));

export const buildNodeNamePrefix = (assetId: string): string => `${assetId}-`;

export const isNodeNameMatchForPath = (nodeNames: string[] | undefined, depPath: string): boolean => {
  if (!nodeNames || nodeNames.length === 0) return false;
  const filename = depPath.includes('/') ? depPath.slice(depPath.lastIndexOf('/') + 1) : depPath;
  return nodeNames.some(nodeName => {
    const colonIndex = nodeName.lastIndexOf(':');
    const nodeFilename = colonIndex > 0 ? nodeName.slice(0, colonIndex) : nodeName;
    return nodeFilename.toLowerCase() === filename.toLowerCase();
  });
};
